/* eslint-disable react/jsx-props-no-spreading */
import clsx from 'clsx';
import { useCallback } from 'react';
import React from 'react';
import { components } from 'react-select';
import { OptionProps } from 'react-select';
import { GroupBase } from 'react-select';
import { SvgIcon } from '../../../../../base-components/SvgIcon';
import styles from './Option.module.scss';

export interface OptionCustomProps<Option> {
    selectedItem: Option | null;
    onOptionSelectClick: () => void;
}

export const Option = <
    Option,
    IsMulti extends boolean = boolean,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    children,
    ...props
}: OptionProps<Option, IsMulti, Group>) => {
    const {
        selectProps: { customProps },
        data: option,
    } = props;

    const { selectedItem, onOptionSelectClick } =
        customProps as OptionCustomProps<Option>;

    const isSelected = selectedItem && option === selectedItem;

    const handleMouseDown = useCallback(
        (event: React.SyntheticEvent) => {
            event.preventDefault();
            event.stopPropagation();
            onOptionSelectClick();
        },
        [onOptionSelectClick]
    );

    return (
        <components.Option {...props}>
            {children}
            <div
                onMouseDown={handleMouseDown}
                className={clsx(styles.plus, !isSelected && styles.hidden)}
            >
                <SvgIcon size={24}>
                    <path d="M21 6.285 9.84 19.018 3 13l1.319-1.49 5.341 4.686L19.525 5 21 6.285z" />
                </SvgIcon>
            </div>
        </components.Option>
    );
};
